import type { Artifact } from '@alatzidis/core'

export const SOUND_ARTIFACTS: Artifact[] = [
  {
    number: 's·00',
    title: 'Pulse Check',
    blurb:
      'The shared audio core, made audible. A click track scheduled on the audio clock rather than by a timer, a two-note drone to prove polyphony, and a meter reading the master bus. Everything else in this section is built on these parts.',
    href: '/sound/pulse',
  },
  {
    number: 's·01',
    title: 'Piano',
    blurb:
      'An acoustic piano built from sine waves placed where a real string would put them. Piano strings are stiff, so their partials run sharp of the harmonic series and get sharper as they climb — that one fact is most of the difference between a piano and an organ. Two detuned strings per note, per-partial decay, a sustain pedal, and a stiffness knob you can turn until it becomes a bell.',
    href: '/sound/piano',
  },
  {
    number: 's·02',
    title: 'Studio',
    blurb:
      'Three channels on one clock: a two-oscillator subtractive synth, a drum machine with no drums in it, and a step sequencer whose rows are scale degrees. Each with a fader, a mute, a solo and a post-fader meter — and each with its full editor a tab away, so you can turn the filter while the pattern keeps running.',
    href: '/sound/studio',
  },
  {
    number: 's·03',
    title: 'Strings',
    blurb:
      'A plucked string, simulated rather than described: a delay line the length of the string, a filter standing in for the bridge, and a burst of noise to start it. Nothing decides what the harmonics should be — they appear because a wave can only fit into a fixed length a whole number of times. The loudest control is where you plucked it, which erases every harmonic that has a node under your finger.',
    href: '/sound/strings',
  },
  {
    number: 's·04',
    title: 'Reed',
    blurb:
      'A blown pipe: a delay line driven through a valve that opens and shuts on the pressure coming back at it. Because the loop is active rather than passive it does not decay, it oscillates — which means it has a threshold, and under that threshold there is no note at all rather than a quiet one. The open end reflects a wave upside down, so only the odd harmonics fit and the register key goes up a twelfth instead of an octave.',
    href: '/sound/reed',
  },
]
